import axios from 'axios'
import { cca_config } from '../../plugins/cca-config'
import guardSession from '@/api/session-guard'
import store from '@/store'

// Jetons d'accès réutilisables (rendez-vous, tableau d'accueil, tableau financier, portail, prescripteurs) : un seul
// appel au serveur, partagé par tous les écrans tant que le jeton reste valide, au lieu d'un appel avant chaque requête
// (05/10/2026, tableau de bord : /rendez-vous/access demandé 4 fois). Les jetons de trésorerie, de paiement,
// de passage au portail et de réattribution ne sont jamais réutilisés.
const ACCES_PARTAGES = ['/rendez-vous/access', '/accueil/tableau-access', '/admin/finance-dashboard-access', '/portail/access', '/prescripteurs/access']
// Gardé 20 s de moins que sa durée annoncée : le jeton n'arrive jamais expiré au serveur.
const MARGE_SECONDES = 20
const accesPartages = {}

const corpsVide = data => data == null || (typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length === 0)
// Chaque écran reçoit sa copie de la réponse : aucun ne peut modifier celle des autres.
const copie = reponse => Object.assign({}, reponse, { data: JSON.parse(JSON.stringify(reponse.data)) })

function accesPartage(post, url, config, token) {
    const role = store.getters['activeRole']
    // Même session, même rôle actif et mêmes options de traitement des erreurs : même jeton.
    const options = Object.keys(config || {}).filter(k => config[k] === true).sort().join(',')
    const cle = [url, token, role && role.id != null ? role.id : '', options].join('|')
    const maintenant = Date.now()
    Object.keys(accesPartages).forEach(k => { if (accesPartages[k].jusqua <= maintenant) delete accesPartages[k] })
    if (!accesPartages[cle]) {
        const entree = { jusqua: Infinity }   // en cours : partagé avec les appels simultanés
        entree.promesse = post(url, {}, config).then(reponse => {
            const corps = reponse && reponse.data
            const duree = corps && corps.success === true && corps.data && typeof corps.data.access_token === 'string'
                ? Number(corps.data.expires_in) - MARGE_SECONDES : 0
            if (accesPartages[cle] === entree) {
                if (duree > 0) entree.jusqua = Date.now() + duree * 1000
                else delete accesPartages[cle]
            }
            return reponse
        }, erreur => {
            if (accesPartages[cle] === entree) delete accesPartages[cle]
            throw erreur
        })
        accesPartages[cle] = entree
    }
    return accesPartages[cle].promesse.then(copie)
}

export default () => {
    const auth_info = store.getters['authInfo']

    let token = ''
    if (auth_info) {
        token = (Object.prototype.hasOwnProperty.call(auth_info, 'access_token'))?auth_info.access_token:''
    }
    

    const instance = axios.create({
        baseURL: cca_config.C_URL+cca_config.C_URL_CONFIG_API,
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })

    // Add a response interceptor
    instance.interceptors.response.use(
        response => response, // Return response if successful
        async error => {
            const request_config = error.config || {}
            if (request_config.admin_finance_access_request && request_config.url === '/admin/finance-dashboard-access') return Promise.reject(error)
            if (request_config.prescripteurs_scoped && request_config.url === '/prescripteurs/access') return Promise.reject(error)
            if (request_config.med003_access_request && request_config.url === '/tresorerie/remuneration-access') {
                return Promise.reject(error)
            }
            if (request_config.med003_paiement_access_request && request_config.url === '/tresorerie/paiement-access') {
                return Promise.reject(error)
            }
            if (request_config.versement_reception_access_request && request_config.url === '/tresorerie/versement-reception-access') {
                return Promise.reject(error)
            }
            await guardSession(error, token)
            return Promise.reject(error);
        }
    );
    if (typeof instance.post === 'function') {
        const post = instance.post.bind(instance)
        instance.post = (url, data, config) => token && ACCES_PARTAGES.indexOf(url) >= 0 && corpsVide(data)
            ? accesPartage(post, url, config, token) : post(url, data, config)
    }
    return instance
}
